export class ViewAllUnits {
  showUnitDescription = false;
  showUnitDescriptionInsteadOfAmenities = false;
  rentSummary: string;
  rentSummaryTitle: boolean;
  reserveSummary: string;
  reserveSummaryTitle: boolean;
  showSizeFilters: boolean;
  showFeaturesFilters: boolean;
  showClimate: boolean;
  showInside: boolean;
  showPowerOutlet: boolean;
  showUnitAlarm: boolean;
  showGroundFloor: boolean;
  showSecondFloor: boolean;
  groundFloor: number;
  showAllText: string;
  _$visited?: any;
  filters: {
    walkInCloset: string,
    walkInClosetDescription?: string,
    midSizeRoom: string,
    midSizeRoomDescription?: string,
    familyRoom: string,
    familyRoomDescription?: string,
    threeBedrooms: string,
    threeBedroomsDescription?: string,
    fullHouse: string,
    fullHouseDescription?: string,
    largeHouse: string,
    largeHouseDescription?: string
  };
  show5x5 = true;
  show5x10 = true;
  show10x10 = true;
  show10x15 = true;
  show10x20 = true;
  show10x25 = true;
  filterUnitsByUnitType = false;
  useBoatIconForParking = false;

  holidays = {
    newYears: false,
    mlk: false,
    washingtonBirthday: false,
    armedForces: false,
    memorial: false,
    flag: false,
    independence: false,
    labor: false,
    columbus: false,
    veterans: false,
    thanksgiving: false,
    christmas: false,
    christmasEve: false,
    newYearsEve: false
  };

  constructor() {
    this.rentSummary = "a unit for future use and pay 1st month rent online. Visit the office during office hours to complete your move in.";
    this.reserveSummary = "a unit for future use, no fee required. You must visit the office during office hours to complete your move in.";
    this.showFeaturesFilters = true;
    this.rentSummaryTitle = true;
    this.reserveSummaryTitle = true;
    this.showSizeFilters = true;
    this.groundFloor = 1;
    this.showClimate = true;
    this.showInside = true;
    this.showPowerOutlet = true;
    this.showUnitAlarm = true;
    this.showGroundFloor = true;
    this.showSecondFloor = false;
    this.showAllText = 'Show All';
    this.filters = {
      walkInCloset: 'Walk-in Closet',
      midSizeRoom: 'Mid-size Room',
      familyRoom: 'Family Room',
      threeBedrooms: '3 Bedrooms',
      fullHouse: 'Full House',
      largeHouse: 'Large House'
    };
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/viewAllUnits.ts